'use strict';

var AdditionalServiceModalCtrl = function (
    additionalService,
    office,
    services,
    gettextCatalog,
    OfficeDA,
    Notification,
    modalInstance,
    taxes
) {
    this._modalInstance = modalInstance;
    this._Notification = Notification;
    this._OfficeDA = OfficeDA;
    this.gettextCatalog = gettextCatalog;
    this.office = office;
    this.services = services;
    this.taxes = taxes;
    this.maxAmounts = [
        {value: 0, label: this.gettextCatalog.getString('unlimited')},
        {value: 1, label: 1},
        {value: 2, label: 2},
        {value: 3, label: 3},
        {value: 4, label: 4},
        {value: 5, label: 5},
        {value: 6, label: 6},
        {value: 7, label: 7},
        {value: 8, label: 8},
        {value: 9, label: 9},
        {value: 10, label: 10},
    ];
    this.additionalService = additionalService || {
        name: '',
        inernal: false,
        extendDuration: true,
        duration: 5,
        price: '0',
        tax: taxes[0].value,
        maxAmount: 0,
        text: ''
    };
    this.formSubmitted = false;
    this.form = null;
    this.selectedService = null;
};

AdditionalServiceModalCtrl.prototype.abort = function () {
    this._modalInstance.close('abort');
};

AdditionalServiceModalCtrl.prototype.save = function () {
    this.formSubmitted = true;
    // this._Notification.addSuccessMessage(this.gettextCatalog.getString('Attachment uploaded'));
    // this._Notification.addErrorMessage(this.gettextCatalog.getString('File extension not of type [PDF]'));
};

module.exports = AdditionalServiceModalCtrl;
